import type { CbamModifiers, EuaPriceQuartersState } from '@/shared/types/cbamModifiers'

export type ModifiersFormState = {
  cscfPercentage: string
  euaPriceQuarters: EuaPriceQuartersState
}

export function euaQuarterValueToPayloadString(value: number | null): string | null {
  if (value == null || Number.isNaN(value)) {
    return null
  }
  return String(value)
}

export function getModifiersFormStateFromCbamModifiers(modifiers: CbamModifiers): ModifiersFormState {
  return {
    cscfPercentage: modifiers.cscfPercentage ?? '100',
    euaPriceQuarters: {
      Q1: {
        ...modifiers.euaPriceQuarters?.Q1,
        value: modifiers.euaPriceQuarters?.Q1?.value
          ? parseFloat(modifiers.euaPriceQuarters?.Q1?.value)
          : null,
        isOfficialValueLocked: modifiers.euaPriceQuarters?.Q1?.isOfficialValueLocked
      },
      Q2: {
        ...modifiers.euaPriceQuarters?.Q2,
        value: modifiers.euaPriceQuarters?.Q2?.value
          ? parseFloat(modifiers.euaPriceQuarters?.Q2?.value)
          : null,
        isOfficialValueLocked: modifiers.euaPriceQuarters?.Q2?.isOfficialValueLocked
      },
      Q3: {
        ...modifiers.euaPriceQuarters?.Q3,
        value: modifiers.euaPriceQuarters?.Q3?.value
          ? parseFloat(modifiers.euaPriceQuarters?.Q3?.value)
          : null,
        isOfficialValueLocked: modifiers.euaPriceQuarters?.Q3?.isOfficialValueLocked
      },
      Q4: {
        ...modifiers.euaPriceQuarters?.Q4,
        value: modifiers.euaPriceQuarters?.Q4?.value
          ? parseFloat(modifiers.euaPriceQuarters?.Q4?.value)
          : null,
        isOfficialValueLocked: modifiers.euaPriceQuarters?.Q4?.isOfficialValueLocked
      }
    }
  }
}

export function serializeModifiersForChangeDetection(
  modifiers: ModifiersFormState,
  appliedCscf: number
): string {
  return JSON.stringify({
    cscfPercentage: String(appliedCscf),
    euaPriceQuarters: {
      Q1: {
        ...modifiers.euaPriceQuarters.Q1,
        value: euaQuarterValueToPayloadString(modifiers.euaPriceQuarters.Q1.value),
        isOfficialValueLocked: modifiers.euaPriceQuarters.Q1.isOfficialValueLocked
      },
      Q2: {
        ...modifiers.euaPriceQuarters.Q2,
        value: euaQuarterValueToPayloadString(modifiers.euaPriceQuarters.Q2.value),
        isOfficialValueLocked: modifiers.euaPriceQuarters.Q2.isOfficialValueLocked
      },
      Q3: {
        ...modifiers.euaPriceQuarters.Q3,
        value: euaQuarterValueToPayloadString(modifiers.euaPriceQuarters.Q3.value),
        isOfficialValueLocked: modifiers.euaPriceQuarters.Q3.isOfficialValueLocked
      },
      Q4: {
        ...modifiers.euaPriceQuarters.Q4,
        value: euaQuarterValueToPayloadString(modifiers.euaPriceQuarters.Q4.value),
        isOfficialValueLocked: modifiers.euaPriceQuarters.Q4.isOfficialValueLocked
      }
    }
  } satisfies CbamModifiers)
}
